import { render, staticRenderFns } from "./CentroCostos.vue?vue&type=template&id=3a73db3e"
import script from "./CentroCostos.vue?vue&type=script&lang=js"
export * from "./CentroCostos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports